<div class="my-3 mx-2">
    <h1 mat-dialog-title>
        Do Not Notify Guest For Additional Information?
    </h1>
    <div mat-dialog-content class="m-2">
        <p>Please confirm you would not like to notify guest(s) for any additional information.</p>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button class="action-button" (click)="onConfirmClick()">
            Ok
        </button>
    </div>
</div>